import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useUpdateReserveReason() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const updateReserveReason = async (
    reason_id,
    reason_message,
    description,
    icon,
    criticality,
    types
  ) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/reserve-reasons/${reason_id}`, {
        reason_message,
        description,
        criticality,
        types,
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200) {
        setIsSuccess(true);
        toast.success(
          response.data?.message ||
            'Catégorie de réserve mise à jour avec succès.'
        );
      } else {
        setIsSuccess(false);
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(error?.response.data?.message || error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    updateReserveReason,
  };
}
